import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/None.svg")